import PaiFooter from "./Footer.vue";

export default PaiFooter;
